module.exports = __webpack_public_path__ + "img/horizontal_6_4_8017.6b2a75db.png";